import { useRef } from "react";
import axios from 'axios';
import moment, { isMoment } from "moment";
import { getLocale, history } from 'umi';
import numeral from 'numeral';
import { isWindow } from '@/pages/dashboard/utils/system';
import {
  MATCH_ROUTE_REG,
  PAGE_TYPE_URL,
  PAGE_TYPE_WORKBOOK,
  PAGE_TYPE_PATH,
  PAGE_TYPE_DASHBOARD_CUSTOM,
  PAGE_TYPE_DASHAPP,
  FILTER_KEY_MAP,
  EXTRA_FILTER_KEY_MAP,
  PAGE_TYPE_DATALAB,
  PAGE_TYPE_TABLEAU,
  PAGE_TYPE_PRESET,
  PAGE_TYPE_PDF,
  PAGE_TYPE_COS_URL,
  PAGE_TYPE_PUBLIC_URL,
  PAGE_URL_KEY,
  PLATFORM_MAP,
  PERIODTIMEOBJ,
  PAGE_TYPE_LOOKER,
  PAGE_PATH_MAP,
  DATALAB_PAGE_PATH,
  PAGE_TYPE_OUT_PATH,
  PAGE_TYPE_AUTH_PATH,
  PAGE_TYPE_OUT_URL
} from '@/pages/dashboard/_config/constant';
import { RANGE_TIME_LIMIT, RANGE_TIME_LIMIT_BY_GAME, RANGE_TIME_LIMIT_NOT_GLOBAL } from '@/pages/dashboard/utils/_config/constant';
import { getNameMap, getCnEnNameMap, getSelectorMap } from '@/pages/dashboard/_config/filterListMap';
import { RANGE_DAILY } from '@/pages/dashboard/components/NewFilter/FilterBase/_config';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { getImg } from '@/pages/home/_config/getImgs';
import { downDataTip } from "@/pages/dashboard/utils/downDataTip";
import { findPageSelector } from "@/pages/dashboard/components/NewFilter/util";
import { cloneDeep } from 'lodash-es';
import { getSystemFlag } from '@/pages/dashboard/pages/overview/_config/system';
import { defaultPlatforms } from '@/pages/dashboard/pages/overview/_config/platforms';
import { dateFormatStr } from "../_config/dateFormatConfig";
import { momentFormat } from '@/pages/dashboard/utils/_config/filtersTimeFormat';
import { filterValueType } from '@/pages/dashboard/components/NewFilter/_type';
import { getCustomFilterList } from '@/pages/dashboard/components/NewFilter/customFilterList';
import dateTimeFormat from '@home/utils/dbDataFormat/dateTimeFormat';
import dataFormat from "@home/utils/dbDataFormat/dataFormat";
import { getLastDate } from "@/pages/dashboard/utils/dateUtils";
import { stringToFunction } from '@/pages/dashboard/utils/stringToJson';
import queryString from 'query-string';
import { getLanguage } from "@home/utils/common";
import { IS_GLOBAL } from '@home/_config/config';
import { IFormatRule, IFormatRules } from '@/pages/dashboard/utils/dataFormatter';

interface UrlInfoType {
  system: string; // 平台
  urlType: string | undefined; // url类型 game
  urlId: string | undefined; // gamecode
  realPath: string; // 当前真实路径
}

// 请求参数黑名单
const paramsBlackList = ['diff', 'timeType', 'selector', 'filterDefaultSelect', 'rangeDateKey', 'pagePath', 'stageList', 'defaultStage', 'defaultIconStage', 'timeZone', 'rangeTime', 'filterCatalog', 'defaultRangeTime'];
// const singleDateKeyArr = ['contrast_day', 'date'];
export const formatFilterValues = (filterValue: any, regionKey = 'region', categoryKey = 'category'): any => {
  const obj = {};
  const customFiltersArr: { key: string; filter_list: any; }[] = [];
  const customFilters = getCustomFilterList();
  (Object.keys(filterValue || {})).forEach((key: string) => {
    // 后端入参都是数组类型
    const filterListVal = (typeof filterValue?.[key] === 'string' && customFilters?.includes(key)) ? [filterValue?.[key]] : filterValue?.[key];
    const isCustomFilter = customFilters?.includes(key);
    // 过滤筛选器不需要的传参
    if (paramsBlackList.includes(key)) {
      return;
    }
    if (isCustomFilter) {
      // 处理级联筛选器：提取子值作为 filter_list
      // 注意：级联筛选器的值格式为 { parent: [...], [key]: [...], type: 'parent' | key }
      // 其中 key 是筛选器的 key（如 ua_network），childKey 就是筛选器的 key
      // 传参只传子元素的值，不传父元素相关的传参
      const cascadeValue = filterValue?.[key];
      if (cascadeValue && typeof cascadeValue === 'object' && cascadeValue.type && !Array.isArray(cascadeValue)) {
        // 级联筛选器值格式：{ parent: [...], [key]: [...], type: 'parent' | key }
        // childKey 就是筛选器的 key，直接使用 key 作为 childKey
        const childValues = cascadeValue[key] || [];
        customFiltersArr?.push({
          key,
          filter_list: Array.isArray(childValues) ? childValues : [childValues]
        });
      } else {
        // 普通自定义筛选器
        customFiltersArr?.push(
          {
            key,
            filter_list: filterListVal
          }
        );
      }
    } else {
      if (key === regionKey) {
        const marketList = filterValue?.region?.markets;
        obj.market_list = marketList;
      } else if (key === categoryKey) {
        obj[FILTER_KEY_MAP[key] || key] = filterValue?.category?.category;
        obj[FILTER_KEY_MAP.product] = filterValue?.category?.product;
      } else {
        obj[FILTER_KEY_MAP[key] || key] = filterListVal;
      }
    }
  });
  // 如果有custom_filters则传递给后端，没有则不传
  if (customFiltersArr?.length > 0) {
    return { ...obj, custom_filters: customFiltersArr };
  }
  return obj;
};

/**
 * monthly页面添加last_date 入参
 * @param params 入参
 * @param haveLastDate boolean 是否添加last_date
 * @param timeZone number 时区
 * @returns 如果日期字符串属于当前月份返回 true，否则返回 false
 */
export const addLastDateRequestValue = (params, haveLastDate, timeZone) => {
  const paramResult = cloneDeep(params);
  if (haveLastDate) {
    paramResult.last_date = getLastDate(timeZone);
  }
  return paramResult;
};


/**
 * 判断给定的日期字符串是否属于当前月份
 * @param dateString 日期字符串，格式为 YYYY-MM-DD
 * @returns 如果日期字符串属于当前月份返回 true，否则返回 false
 */
export const isDateInCurrentMonth = (dateString: string, timeZone: number): boolean => {
  const date = moment(dateString, 'YYYY-MM-DD');
  // 和当前年份以及月份比较，当前年月份为：当前日期的T-1对应时区偏移后的年月
  const currentEndDate = moment(moment().utcOffset(timeZone).format('YYYY-MM-DD HH:mm:ss')).startOf('day');
  const monthEndVal = currentEndDate.subtract(1, 'days');
  return date.year() === monthEndVal.year() && date.month() === monthEndVal.month();
};

export const formatAccumulation = (accumulated: any) => {
  const customAccumulationKeys = getCustomFilterList();
  const customAccumulationArr: { key: string; is_accumulation: boolean; }[] = [];

  // 处理自定义累积值
  customAccumulationKeys.forEach((key) => {
    if (accumulated.includes(key)) {
      customAccumulationArr.push({
        key,
        is_accumulation: true
      });
    }
  });

  const result = {
    not_by_date: !accumulated.includes('date'),
    by_zone: accumulated.includes('zone'),
    by_region: accumulated.includes('region'),
    by_country: accumulated.includes('country'),
    by_channel: accumulated.includes('channel'),
    by_system: accumulated.includes('system'),
    by_language: accumulated.includes('language'),
    by_bundle: accumulated.includes('bundle'),
    by_churn_level: accumulated.includes('churn_level'),
    by_product: accumulated.includes('product'),
    by_category: accumulated.includes('category')
  };

  // 如果有 custom_accumulation 则添加到返回结果中
  if (customAccumulationArr.length > 0) {
    return { ...result, custom_accumulation: customAccumulationArr };
  }

  return result;
};

// 经分路径解析
export function parseUrlInfo(str = ''): UrlInfoType {
  const pathParts = str.trim().split('/').filter(Boolean);
  // 兼容带版本前缀路由（如 /v2/dashboard/...）
  const prefixOffset = /^v\d+$/i.test(pathParts[0] || '') ? 1 : 0;
  const [system = '', urlType = '', urlId = '', ...arr] = pathParts.slice(prefixOffset);
  const realPath = arr.length > 0 ? arr.join('/') : '';
  return {
    system,
    urlType,
    urlId,
    realPath,
  };
}

const PAGE_TYPE_LIST = [
  PAGE_TYPE_PATH,
  PAGE_TYPE_DATALAB,
  PAGE_TYPE_PRESET,
  PAGE_TYPE_PDF,
  PAGE_TYPE_COS_URL,
  PAGE_TYPE_DASHAPP,
  PAGE_TYPE_PUBLIC_URL,
  PAGE_TYPE_DASHBOARD_CUSTOM,
  PAGE_TYPE_LOOKER,
  PAGE_TYPE_OUT_PATH,
  PAGE_TYPE_AUTH_PATH,
  PAGE_TYPE_OUT_URL
];

// 获取报表具体类型，path，datalab，preset，tableau, pdf
export function getDashboardPathType(dashboard: any): string {
  if (dashboard?.page_type === PAGE_TYPE_PATH || (!dashboard?.page_type && dashboard?.path)) {
    return PAGE_TYPE_PATH;
  }

  if (dashboard?.page_type === PAGE_TYPE_WORKBOOK) {
    return PAGE_TYPE_WORKBOOK;
  }

  if (PAGE_TYPE_LIST.includes(dashboard?.page_type)) {
    return dashboard?.page_type;
  }

  if (dashboard?.url) {
    return PAGE_TYPE_URL;
  }

  return PAGE_TYPE_URL;
}

// 获取报表类型，path，datalab，preset，tableau, pdf， 注意：PAGE_TYPE_URL、PAGE_TYPE_WORKBOOK、PAGE_TYPE_TABLEAU 同属于 PAGE_TYPE_TABLEAU
export function getDashboardType(dashboard: any): string {
  if (dashboard?.page_type === PAGE_TYPE_PATH || (!dashboard?.page_type && dashboard?.path)) {
    return PAGE_TYPE_PATH;
  }

  if (PAGE_TYPE_LIST.includes(dashboard?.page_type)) {
    return dashboard?.page_type;
  }

  return PAGE_TYPE_TABLEAU;
}

// 获取dashboard的相对路径，非/开头
export function getPathFromDashboard(dashboard: any, raw = true): string {
  // 防御性处理：dashboard 为空时返回空字符串
  if (!dashboard) return '';

  const dashboardType = getDashboardType(dashboard);

  if (dashboardType === PAGE_TYPE_PATH) {
    return dashboard.path.replace(/^\//, '');
  }

  if (dashboardType === PAGE_TYPE_DATALAB) {
    return `${DATALAB_PAGE_PATH}/${dashboard?.[PAGE_URL_KEY[PAGE_TYPE_DATALAB]]}`;
  }

  // if (dashboardType === PAGE_TYPE_DASHBOARD_CUSTOM) {
  //   return `${CUSTOM_DASHBOARD_PAGE_PATH}/${raw ? getReportId(dashboard) : getCustomDashboardId(dashboard)}`
  // }

  // if (dashboardType === PAGE_TYPE_PRESET) {
  //   // return `${PRESET_PAGE_PATH}/${dashboard?.[PAGE_URL_KEY[PAGE_TYPE_PRESET]]}`
  //   return `${PRESET_PAGE_PATH}/${getPresetReportId(dashboard)}`
  // }
  //
  // if (dashboardType === PAGE_TYPE_PDF) {
  //   return `${TABLEAU_PAGE_PDF}/${getPdfReportId(dashboard)}`
  // }
  //
  // if (dashboardType === PAGE_TYPE_COS_URL) {
  //   return `${TABLEAU_PAGE_COS_URL}/${getHtmlReportId(dashboard)}`
  // }
  //
  // if (dashboardType === PAGE_TYPE_DASHAPP) {
  //   return `${DASHAPP_PAGE_PATH}/${getDashAppReportId(dashboard)}`
  // }
  //
  // if (dashboardType === PAGE_TYPE_PUBLIC_URL) {
  //   return `${PUBLIC_URL_PAGE_PATH}/${getPublicUrlReportId(dashboard)}`
  // }
  // if (dashboardType === PAGE_TYPE_LOOKER) {
  //   return `${LOOKER_PAGE_PATH}/${getLookerReportId(dashboard)}`
  // }

  return `${PAGE_PATH_MAP[dashboardType] || PAGE_PATH_MAP.default}/${raw ? getReportId(dashboard) : getReportIdFromName(dashboard?.name_en)}`;
}

export function checkReportIdWithName(pathReportId: string, name: string): boolean {
  if (pathReportId === getRawReportIdFromName(name)) {
    return true;
  }

  if (pathReportId === getReportIdFromName(name)) {
    return true;
  }

  return false;
}

function getRawReportIdFromName(name: string) {
  if (!name) {
    return '';
  }
  return name?.trim() || '';
}

function getReportIdFromName(name: string) {
  if (!name) {
    return '';
  }
  return name?.replaceAll(' ', '-') || '';
}

// // 获取tableau报表的reportid
// export function getTableauReportId(dashboard: any): string {
//   // const dashboardType = getDashboardType(dashboard);
//   // if (dashboardType !== PAGE_TYPE_TABLEAU) {
//   //   return '';
//   // }
//   return getRawReportIdFromName(dashboard?.name_en);
// }
//
// // 获取preset报表的reportid
// export function getPublicUrlReportId(dashboard: any): string {
//   const dashboardType = getDashboardType(dashboard);
//   if (dashboardType !== PAGE_TYPE_PUBLIC_URL) {
//     return '';
//   }
//   return getRawReportIdFromName(dashboard?.name_en);
// }
//
// // 获取pdf报表
// export function getPdfReportId(dashboard: any): string {
//   const dashboardType = getDashboardType(dashboard);
//   if (dashboardType !== PAGE_TYPE_PDF) {
//     return '';
//   }
//   return getRawReportIdFromName(dashboard?.name_en);
// }
//
// export function getHtmlReportId(dashboard: any): string {
//   const dashboardType = getDashboardType(dashboard);
//   if (dashboardType !== PAGE_TYPE_COS_URL) {
//     return '';
//   }
//   return getRawReportIdFromName(dashboard?.name_en);
// }
//
// // 获取dashApp报表的reportid
// export function getDashAppReportId(dashboard: any): string {
//   const dashboardType = getDashboardType(dashboard);
//   if (dashboardType !== PAGE_TYPE_DASHAPP) {
//     return '';
//   }
//   return getRawReportIdFromName(dashboard?.name_en);
// }
//
// // 获取looker报表的reportid
// export function getLookerReportId(dashboard: any): string {
//   const dashboardType = getDashboardType(dashboard);
//   if (dashboardType !== PAGE_TYPE_LOOKER) {
//     return '';
//   }
//   return getRawReportIdFromName(dashboard?.name_en);
// }
//
// // 获取preset报表的reportid
// export function getPresetReportId(dashboard: any): string {
//   const dashboardType = getDashboardType(dashboard);
//   if (dashboardType !== PAGE_TYPE_PRESET) {
//     return '';
//   }
//   return getRawReportIdFromName(dashboard?.name_en);
// }

export function getReportId(dashboard: any): string {
  return getRawReportIdFromName(dashboard?.name_en);
}

// 获取custome dashboard报表的报表id
export function getCustomDashboardId(dashboard: any): string {
  const dashboardType = getDashboardType(dashboard);
  if (dashboardType !== PAGE_TYPE_DASHBOARD_CUSTOM) {
    return '';
  }
  return dashboard?.dashboard_custom_id || '';
}

// 判定当前路径和dashboard是否匹配
export function matchPathWithDashboard(dashboard: any, path: string): boolean {
  const dashboardRawPath = getPathFromDashboard(dashboard);
  const dashboardPath = getPathFromDashboard(dashboard, false);
  const dashboardType = getDashboardType(dashboard);

  if (dashboardType === PAGE_TYPE_PATH) {
    return path === dashboardRawPath || path.startsWith(`${dashboardRawPath}/`);
  }

  return dashboardRawPath === path || dashboardPath === path;
}

// 从特性指标中，查询dashboard
export function getMetricsDashboard(dashboard: any, metricsPath: string): any {
  const reportName = metricsPath.replace('?report=', '');
  return dashboard.find((item: any) =>
    // 看现在的测试环境的demo数据report=后面跟的也可能为 dashboard_uuid (如：/dashboard/game/demo/datalab/report/512)
    (item?.name_en?.toLowerCase() === reportName?.toLowerCase()) || (item.dashboard_uuid === reportName)
  );
}

// 数值是否极值
export const getIsErrorValue = (value: string | number) => {
  if (parseFloat(value) === 0) return false;
  return (!Boolean(value) || !Boolean(parseFloat(value)));
};


/**
 * 数值单位转换成 B/M/K (一般用于echarts Y轴)
 * @param {number} data 原始数值
 * @param {boolean} isFloat 原始数值
 * @returns 转换后的字符串
 */

export const unitConversion = (data: string | number, isFloat = false, fillZero = false, isAbs = false) => {
  if (getIsErrorValue(data)) return '-';
  if (isNaN(Number(data))) return data;
  const value = isAbs ? Math.abs(data) : data;
  return dataFormat({
    value, formatRule: {
      type: 'bmk',
      decimal: isFloat ? 2 : 0
    }, fillZero
  });
};

/**
 * 数值单位转换成 B/M/K (一般用于echarts Y轴)
 * @param {number} data 原始数值
 * @param {boolean} isFloat是否有小数位
 * @param {number} fixedNum 小数位
 * @returns 转换后的字符串
 */

export const unitConversionNew = (data, {
  isFloat = false,
  fixedNum = 2,
  fillZero = true
}) => {
  // 排查了当前页面的调用，isFloat一直为true，fixedNum一直传递为3，后续不要使用这个方法，用最新的方法dataFormat方法直接处理
  if (getIsErrorValue(data)) return '-';
  if (isNaN(Number(data))) return data;
  return dataFormat({
    value: data, formatRule: {
      type: 'bmk',
      decimal: isFloat ? fixedNum : 0,
    }, fillZero
  });
};


/**
 * 处理在 Day, Week , Month不同维度下, 显示的日期格式
 * @param dateDimension 日期维度 WEEK|MONTH|DAY
 * @param date 日期
 * @return 返回处理后符合产品要求的日期格式字符串 string
 */
export const getDateFormatString = (dateDimension, date) => {
  switch (dateDimension) {
    case 'Week': {
      const weekOfDay = moment(date).format('E');
      return moment(date).subtract(Number(weekOfDay) - 1, 'days').format("YYYY-MM-DD");
    }
    case 'Month': {
      return moment(date).format("YYYY-MM");
    }
    case 'Day':
    default:
      return moment(date).format("YYYY-MM-DD");
  }
};


/**
 * @description: 格式化数字 (一般用于表格)
 * @param {Number||String} num
 * @param {boolean} isToFixed 是否保留两位小数
 * @param {number} fixedNumber 保留几位小数
 * @return {String}
 */
export function formatNumOld(num: number, isToFixed = false, fixedNumber = 2) {
  // 先将个数位四舍五入
  if (num / 1 >= 1000) {
    num = Math.round(num / 10) * 10;
  }
  const s = new String(num);
  const arr = s.split('.');
  if (arr[0].length > 3) { // 大于一千
    // 将数字转换为字符串，进行三位分割
    const _num = (`${arr[0]}`).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    // 整数
    const x = new Number(_num.split(',')[0]);
    // 小数
    const x2 = _num.split(',')[1];
    const _arr = ['K', 'M', 'B', 'T'];
    if (!isToFixed) {
      return (`${Math.round(new Number(`${x}.${x2}`) * 100) / 100}${_arr[_num.split(',').length - 2]}`);
    }
    return (`${(Math.round(new Number(`${x}.${x2}`) * 100) / 100).toFixed(fixedNumber)}${_arr[_num.split(',').length - 2]}`);

  } if (arr[1]) { // 小于一千且有小数
    if (!isToFixed) {
      return Math.round(new Number(`${arr[0]}.${arr[1]}`) * 100) / 100;
    }
    return (Math.round(new Number(`${arr[0]}.${arr[1]}`) * 100) / 100).toFixed(fixedNumber);

  }  // 小于一千没有小数
  return num;

}
// 数字增加千分位
export const numFormat = (num) => {
  const result = num
    .toString()
    .replace(/\d+/, (n) => n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => `${$1},`));
  return result;
};

/**
 * 格式化数字 (一般用于表格)
 * @param {String|Number} num 原始数字
 * @param {Boolean} isDollar 是否加$符号
 * @param {Boolean} isUserQuota 是否用户类数据，保留整数
 * @param {string} unit 前置单位,如：$
 * @param {boolean} thousands 是否千分位展示
 * @return {String} 格式化后的字符串
 */
export function formatNum(num: string | number, isDollar = false, isUserQuota = false, unit = '$', thousands = true) {
  let result = '';
  if (getIsErrorValue(num)) return '-';
  if (isNaN(Number(num))) return num;
  // 原有逻辑，是整数则直接返回
  if (String(num).indexOf('.') === -1) {
    return isDollar ? unit + dataFormat({ value: num, formatRule: thousands ? 'thousandsInit' : 'int' }) : dataFormat({ value: num, formatRule: thousands ? 'thousandsInit' : 'int' });
  };

  // 优化逻辑如下：
  //  保留千分位整数
  if (isUserQuota && thousands) {
    result = dataFormat({ value: num, formatRule: 'thousandsInit' });
  }
  // 保留整数
  if (isUserQuota && !thousands) {
    result = dataFormat({ value: num, formatRule: 'int' });
  }
  // 保留千分位2位小数
  if (!isUserQuota && thousands) {
    result = dataFormat({ value: num, formatRule: 'thousands2Decimal' });
  }
  // 保留2位小数
  if (!isUserQuota && !thousands) {
    result = dataFormat({ value: num, formatRule: 'twoDecimal' });
  }
  // 是否有单位
  if (isDollar) {
    return `${unit}${result}`;
  }
  return result;
}

// 百分数坐标轴
export function formatTruNum(num, isToFixed = false, fixedNumber = 2) {
  // 先将个数位四舍五入
  if (num / 1 >= 1000) {
    num = Math.round(num / 10) * 10;
  }
  const s = new String(num);
  const arr = s.split('.');
  if (arr[0].length > 3) { // 大于一千
    // 将数字转换为字符串，进行三位分割
    const _num = (`${arr[0]}`).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    // 整数
    const x = new Number(_num.split(',')[0]);
    // 小数
    const x2 = _num.split(',')[1];
    const _arr = ['K', 'M', 'B', 'T'];
    if (!isToFixed) {
      return (`${Math.round(new Number(`${x}.${x2}`) * 100) / 100}${_arr[_num.split(',').length - 2]}`);
    }
    const pow = Math.pow(10, fixedNumber);
    return (`${(Math.round(new Number(`${x}.${x2}`) * pow) / pow).toFixed(fixedNumber)}${_arr[_num.split(',').length - 2]}`);

  } if (arr[1]) { // 小于一千且有小数
    if (!isToFixed) {
      return Math.round(new Number(`${arr[0]}.${arr[1]}`) * 100) / 100;
    }
    return (Math.round(new Number(`${arr[0]}.${arr[1]}`) * 100) / 100).toFixed(fixedNumber);

  }  // 小于一千没有小数
  return num;

}

/**
 * @description:
 默认保留两位小数，涨跌和占比保留一位小数
 如果小数位数不足保留的位数, 则需要补0
 涨跌为 0.0 展示 0,
 如果是空字符串，则显示为横杠 -
 百分比如果超过999.9， 则显示为999.9%+
 * @param {Number} num
 * @param {Number} fixedNumber 保留多少位小数，只保留0到4位小数
 * @param {Boolean} isFloating 是否为涨浮
 * @param {Boolean} isBigPercent 是否为极大数据，目前ua有用到
 * @param {Boolean} isLimitDecimals 是否限制小数位
 * @return {String}
 */
export const formatPercentNum = (num: number, fixedNumber = 2, isFloating = false, isBigPercent = false, isLimitDecimals = true) => {
  if (getIsErrorValue(num)) return '-';
  if (isNaN(num)) return num;
  // 原方法是正值，这里保持原有逻辑，取正值
  const number = Math.abs(num);
  const regPos = /^\d+$/;
  let decimal = fixedNumber;
  // 不在0到4之间或者不是整数并且限制小数位则保留两位小数
  if ((fixedNumber < 0 || fixedNumber > 4 || !regPos.test(fixedNumber)) && isLimitDecimals) {
    decimal = 2;
  }
  // 如果为涨幅则保留一位小数
  if (isFloating) {
    decimal = 1;
  }
  return dataFormat({ value: number, formatRule: { type: isBigPercent ? 'bigPercent' : 'percent', decimal } });
};

export const formatPercentNumNoPercent = (num: number, fixedNumber = 2) => {
  if (getIsErrorValue(num)) return '';
  if (isNaN(num)) return num;
  // 只保留0到4位小数
  const regPos = /^\d+$/;
  if (fixedNumber < 0 || fixedNumber > 4 || !regPos.test(fixedNumber)) fixedNumber = 2;

  // 取绝对值，因为会传进来负数
  const number = Math.abs(num);
  // 先放大 100 * 10 * fixedNumber 倍，再除 10 * fixedNumber，就能获取到四舍五入后的百分值
  const fixedPow = Math.pow(10, 2 + fixedNumber);
  const floatPow = Math.pow(10, fixedNumber);
  const percentage = (Math.round(number * fixedPow) / floatPow).toFixed(fixedNumber) / 100; // toFixed为了补足小数位数
  return percentage;
};

export const splitDate = (dateStr: string) => `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6)}`;

export const splitDateTimeNoSpace = (dateStr: string) => {
  const year = dateStr.slice(0, 4) || '00';
  const month = dateStr.slice(4, 6) || '00';
  const day = dateStr.slice(6, 8) || '00';
  const hour = dateStr.slice(8, 10) || '00';
  const min = dateStr.slice(10, 12) || '00';
  return `${year}-${month}-${day} ${hour}:${min}`;
};

export const splitDateTime = (dateStr: string) => {
  const year = dateStr.slice(0, 4) || '00';
  const month = dateStr.slice(5, 7) || '00';
  const day = dateStr.slice(8, 10) || '00';
  const hour = dateStr.slice(11, 13) || '00';
  const min = dateStr.slice(14, 16) || '00';
  return `${year}-${month}-${day} ${hour}:${min}`;
};

// 首字母大写
export const toUpperFirstCase = (str) => {
  if (!str) {
    return '';
  }
  return str?.slice(0, 1)?.toUpperCase() + str?.slice(1)?.toLowerCase();
};

/**
 * 页面实时刷新
 * @param {*} fn 要执行的操作
 * @param {number} interval 时间间隔（分）
 * @param {string} type 定时器类型
 * @returns 定时器对象
 */
export const realTimeRefresh = (fn: () => void, interval: number, type = 'interval') => {
  if (type === 'interval') {
    return setInterval(() => fn(), interval * 60 * 1000);
  } if (type === 'timeout') {
    return setTimeout(() => fn(), interval * 60 * 1000);
  }
};


/**
 * 下载文件
 * @param response 接口返回值
 * @param name 文件名
 * @param downhide 下载中 的“通知实体”
 * @param tipSuccess 下载成功的文本内容 表名 + 下载成功
 * @param tipError 下载失败的文本内容 表名 + 下载失败
 * @param setIsDownLoading 关闭下载中的状态
 */
export const downloadFile = (response: BlobPart, name: string, tipSuccess: any, tipError: any, tipLoading: any) => {
  const notificationRef = useRef({ destroy: () => { } });
  const blob = new Blob([response], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const linkNode = document.createElement('a');
  linkNode.download = name; // a标签的download属性规定下载文件的名称
  linkNode.style.display = 'none';
  linkNode.href = URL.createObjectURL(blob); // 生成一个Blob URL
  document.body.appendChild(linkNode);
  linkNode.click(); // 模拟在按钮上的一次鼠标单击

  // if (downhide) {
  if (blob.size < 100 && tipError) {
    notificationRef.current.destroy();
    downDataTip('error', tipError);
    // setIsDownLoading(false)
    return;
  }
  axios({
    url: linkNode.href,
    method: "get",
    responseType: "blob",
    onDownloadProgress: progressEvent => {
      if (Math.round(progressEvent.loaded / progressEvent.total * 100) <= 99) {
        notificationRef.current.destroy();
        downDataTip('loading', tipLoading);
      } else {
        if (tipSuccess) {
          notificationRef.current.destroy();
          downDataTip('success', tipSuccess);
          // setIsDownLoading(false)
        }
      }
    }
  }).catch(e => {
    notificationRef.current.destroy();
    // setIsDownLoading(false)
    if (e.message === "Network Error") { // 据说要把跨域请求地址改为https才不会报这个错误
      downDataTip('success', tipSuccess);
      // setIsDownLoading(false)
    } else {
      downDataTip('error', tipError);
    }
  });
  // }

  URL.revokeObjectURL(linkNode.href); // 释放URL 对象
  document.body.removeChild(linkNode);

};

/**
 * 指标名称是否加($)
 * @param {String} text
 * @returns {String}
 */
export const getIsDollarText = (text: string) => ['Revenue', 'ARPU', 'ARPPU', 'new users ARPPU'].includes(text) ? `${text}($)` : text;


// 如果数据为空，则添加等长度的空值，用来浮层的显示“-”
export const getArr = (arr: any[], objArr: string | any[]) => {
  if (arr?.length === 0) {
    return arr.concat(Array(objArr?.length).fill(''));
  }
  return arr;
};

/** *
 * 清除字符串两端空格
 * @param
 */
export function trim(str: string) {
  return str ? str.replace(/(^\s*)|(\s*$)/g, '') : str;
}

/** *
 * 设置cookie
 * @param
 */
export function setCookie(name: string, value: string, expiredays: string | number, path: string, domain: string | undefined) {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    `${name
    }=${escape(value)
    }${!path ? '' : `;path=${path}`
    }${!domain ? '' : `;domain=${domain}`
    }${!expiredays ? '' : `;expires=${exdate.toGMTString()}`}`;
}

/** *
 * 获取cookie
 * @param
 */
export function getCookie(key: string) {
  let temp;
  const arr = document.cookie.split(';').map((item) => {
    temp = item.split('=');
    return { key: trim(temp[0]), value: trim(temp[1]) };
  });
  temp = arr.find((item) => item.key === key);
  return unescape((temp?.value) || '');
}

/** *
 * 清除cookie
 * @param whiteCookie 白名单cookie，白名单中的cookie，不清除
 */
export function clearCookie(whiteCookie = []) {
  const cookies = document.cookie.split(';');
  for (let i = 0;i < cookies.length;i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? trim(cookie.substr(0, eqPos)) : cookie;
    if (whiteCookie.indexOf(name) > -1) {
      continue;
    }
    document.cookie = `${name}=;domain=${location.hostname};expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  }
}

/** *
 * 设置登录
 * @param
 */
export function setLogin(authorization: string) {
  window.sessionStorage.setItem('authorization', authorization);
  setCookie('db-authorization', authorization, '', '/');
}

/**
 * 登出操作
 */
export const doLogout = () => {
  window.sessionStorage.removeItem('authorization');
  window.sessionStorage.removeItem('openId');
  window.sessionStorage.removeItem('userID');
  window.sessionStorage.removeItem('permissions');
  window.sessionStorage.removeItem('userName');

  window.localStorage.removeItem('lockCacheValue');
  clearCookie();
  const redirect = encodeURIComponent(window.location.href);
  // 本地发开跳转本地登录页
  if (process.env.NODE_ENV === 'development') {
    window.location.href = `/dashboard/login?redirect=${redirect}`;
    // location.href = `/dashboard/login?redirect`
  } else {
    window.location.href = `/login?redirect=${redirect}&type=out`;
  }
};

/** *
 * 获取登录token
 * @param
 */

// 从url获取token
export function getAuthFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  const auth = urlParams.get('__author');
  return auth || '';
}

export function getAuthorization() {
  const authInUrl = getAuthFromUrl();
  return (
    authInUrl ||
    getCookie('db-authorization') ||
    window.sessionStorage.getItem('authorization')
  );
}

// 筛选器按钮打点
export const setBtnPointLog = (buttonLogConfig, value, isReset = false) => {
  const { confirmButtonId, resetButtonId, pageId, typeId = 'dashboard_pc_v2' } = buttonLogConfig;
  const logObj = {
    buttonId: isReset ? resetButtonId : confirmButtonId,
    extInfo: JSON.stringify(value),
    pageId,
    typeId,
  };
  (confirmButtonId || resetButtonId) && buriedBtnPoint(logObj);
};

const createCellPos = (columnIndex) => {
  const ordA = 'A'.charCodeAt(0);
  const ordZ = 'Z'.charCodeAt(0);
  const len = ordZ - ordA + 1;
  let str = '';
  while (columnIndex >= 0) {
    str = String.fromCharCode(columnIndex % len + ordA) + str;
    columnIndex = Math.floor(columnIndex / len) - 1;
  }
  return str;
};

export const buildExcelColumns = (maxLength = 0) => {
  const result = [];
  for (let i = 0;i < maxLength;i++) {
    result.push(createCellPos(i));
  }
  return result;
};

/**
 * 获取跌涨的数值和状态
 * @param {* 需要处理的数值 number} num
 * @param {* 是否用于浮窗 boolean} isBubble
 * @returns {text: string, status: 'zero' | 'up' | 'down'}
 */
export const getRatioText = (num: string | number, isBubble = true) => {
  try {
    if (num) {
      num = parseFloat(num);
      const status = (() => {
        if (num == 0) return 'zero';
        if (num > 0) return 'up';
        if (num < 0) return 'down';
        return 'zero';
      })();
      const ratioNumPercent = formatPercentNum(+num, 1, true);
      return {
        text: `${ratioNumPercent}`,
        status,
      };
    } if (num === '' && !isBubble) {
      return {
        text: '-',
        status: '',
      };
    }
    return {
      text: '',
      status: 'no'
    };

  } catch (error) {
    return {
      text: '',
      status: 'no'
    };
  }
};

/**
 * 获取公共上传参数
 * @param formValue
 * @param gameCode
 * @return CommonRequestParams 接口请求上传公共参数
 */
export const getCommonRequestParams = (formValue, gameCode) => {
  const { filterValue } = formValue;
  const { rangeTime: [start, end], ...filters } = filterValue;
  return {
    game_code: gameCode,
    start_time: start,
    end_time: end,
    filters: formatFilterValues(filters)
  };
};

// 首字母大写
export const upperFirstConcat = (value) => {
  let str = value?.toLowerCase();
  str = str.replace(/\b(\w)|\s(\w)/g, (word) => word.toUpperCase());
  return str;
};

// 判断是否单月单周单日
export const IsSingleDay = (param, onlyDay?) => {
  // 新老筛选器兼容处理
  const params = param?.filterValue ? param?.filterValue : param;
  if (onlyDay) return params.start_time === params.end_time;
  // 判断增加是否相同年份
  const isSameYear = moment(params?.rangeTime?.[0]).year() === moment(params?.rangeTime?.[1]).year();
  if (params?.period?.toUpperCase() === "MONTHLY") {
    const [startTime, endTime] = [moment(params?.rangeTime?.[0]).month(), moment(params?.rangeTime?.[1]).month()];
    return isSameYear && startTime === endTime;
  } if (params?.period?.toUpperCase() === "WEEKLY") {
    const [startTime, endTime] = [moment(params?.rangeTime?.[0]).week(), moment(params?.rangeTime?.[1]).week()];
    return isSameYear && startTime === endTime;
  }
  return params?.rangeTime?.[0] === params?.rangeTime?.[1];
};

/**
 * overview宽表获取默认补齐日期逻辑
 * @param rangeTime 筛选器时间
 * @param param1 diff是否更改过筛选器 isHaveDiff配置是否需要补齐
 * @returns 补齐后日期
 */
export const getParamsTime = (filterVal: any, isHaveDiff: boolean) => {
  const { rangeTime = [], diff, timeType } = filterVal || {};
  // eslint-disable-next-line prefer-const
  let [startTime, endTime] = rangeTime;
  /**
   * day 少于七天补足七天
   * week 少于六周补足六周
   * month 少于六月补足六月
   */
  if (diff && isHaveDiff) {
    switch (timeType) {
      case "Day": {
        startTime = moment().subtract(8, 'day').format('YYYY-MM-DD');
        break;
      }
      case "Week": {
        startTime = moment(endTime).week(moment(endTime).week() - 5).startOf('isoWeek').format('YYYY-MM-DD');
        break;
      }
      case "Month": {
        startTime = moment(endTime).month(moment(endTime).month() - 5).startOf('month').format('YYYY-MM-DD');
        break;
      }
    }
  }
  return [startTime, endTime];
};

/**
 * 获取补齐日期 单日近14天 单周近6周 单月近6月
 * @param rangeTime 筛选器时间
 * @param timeType 筛选器时间类型
 * @returns 接口日期参数
 */
export const getCompleteDateValue = (rangeTime: string[], timeType: string, offsetConfig?: any) => {
  if (!Array.isArray(rangeTime)) return rangeTime;
  const { offsetDay = 13, offsetWeek = 5, offsetMonth = 5 } = offsetConfig || {};
  const endTime = rangeTime?.[1];
  const type = timeType?.toLocaleLowerCase();
  const timeConfig: { [key: string]: string[]; } = {
    'day': [moment(endTime).subtract(offsetDay, 'day').format('YYYY-MM-DD'), endTime],
    'week': [moment(endTime).week(moment(endTime).week() - offsetWeek).startOf('isoWeek').format('YYYY-MM-DD'), endTime],
    'month': [moment(endTime).month(moment(endTime).month() - offsetMonth).startOf('month').format('YYYY-MM-DD'), endTime],
  };
  return timeConfig?.[type] || rangeTime;
};

/**
 * 是否是单日单周单月 是则补齐日期
 * @param rangeTime 筛选器时间
 * @param timeType 筛选器时间类型
 * @returns 补齐的日期
 */
export const formatSingleTime = (rangeTime: string[], timeType: string) => {
  if (!Array.isArray(rangeTime)) return rangeTime;
  const period = PERIODTIMEOBJ?.[timeType];
  const isSingle = IsSingleDay({ rangeTime, period });
  if (!isSingle) return rangeTime;
  return getCompleteDateValue(rangeTime, timeType);
};

export const importSvg = (svgName) => {
  try {
    return getImg(svgName);
  } catch (err) {
    console.log(err);
    return '';
  }
};

export const xAxisIntervalFormat = (index: number, xAxisData: string | any[], num = 24) => {
  const count = xAxisData?.length;
  const defaultInterval = parseInt(((count - 1) / num).toString());
  let differNum = count - defaultInterval * num - 1;
  let preIndex = 0;
  // 小于等于14个点全部展示
  if (count <= num) {
    return true;
  }

  if (index === count - 1) {
    // 遍历完数据重置（防止数据被刷掉）
    differNum = count - defaultInterval * num - 1;
    preIndex = 0;
    return true;
  }
  if (index === 0) {
    return true;
  }

  // 间隔数
  const currentInterval = differNum > 0 ? defaultInterval : defaultInterval - 1;
  if (preIndex + 1 + currentInterval === index) {
    differNum = differNum > 0 ? differNum - 1 : 0;
    preIndex = index;
    return true;
  }
  return false;
};

export const mapFlat = (tree: any) => {
  const map = {};
  const flat = (treeObj: { [x: string]: any; }, prefix: string | undefined) => {
    const keys = Object.keys(treeObj);
    for (const key of keys) {
      if (typeof treeObj[key] === 'object') {
        const fullPrefix = prefix ? `${prefix}.${key}` : key;
        flat(treeObj[key], fullPrefix);
      } else {
        const fullKey = prefix ? `${prefix}.${key}` : key;
        map[fullKey] = treeObj[key];
      }
    }
  };
  flat(tree);
  return map;
};
export const gridx = {
  x: '1%',
  y: '6%',
  x2: '1%',
  y2: '9%',
  containLabel: true
};

export const matchRouteUrl = (path: string, pageRouter: string) => {
  const routerPath = path?.replace(MATCH_ROUTE_REG, '/');
  return routerPath === pageRouter;
};
export const matchFuzzyRouteUrl = (path: string, fuzzyRouteUrl) => {
  const currentPathPath = path?.replace(MATCH_ROUTE_REG, '/');

  // 带 * 走前缀匹配，不带走精准匹配
  if (fuzzyRouteUrl.includes('*')) {
    fuzzyRouteUrl = fuzzyRouteUrl.replace(/\*(\w)*/g, '');
    return currentPathPath.indexOf(fuzzyRouteUrl) === 0;
  }
  return matchRouteUrl(path, fuzzyRouteUrl);

};

export const filterValueInit = (oldFormValue: any, newFormValue: { [x: string]: any; }) => {
  const lockCacheValue = localStorage.getItem('lockCacheValue') ? JSON.parse(localStorage.getItem('lockCacheValue')) : null;
  // 继承值优先级高于默认值，不用担心继承来页面不需要的筛选器，后面有一层过滤逻辑会全部过滤掉
  if (lockCacheValue !== null) {
    for (const key in newFormValue) {
      // 筛选器值为null，则代表没有此筛选器，设为A
      // 如果继承的包含A，但是新的配置中配置的是不展示A，那么继承的应该改为不展示A（设置值为null
      // 同时如果继承值不包含A，但是新的配置中有A，则继承值应该添加A，不添加的话，页面展示不出来A
      if (newFormValue[key] == null || (oldFormValue[key] == null && newFormValue[key] !== null)) {
        oldFormValue[key] = newFormValue[key];
      }
    }
    return { ...oldFormValue };
  }
  const initFormValue = { ...oldFormValue };
  const valueAllKeys = Object.keys(newFormValue);
  valueAllKeys.forEach(key => {
    if (key === 'lang') {
      initFormValue.language = newFormValue[key];
    }
    initFormValue[key] = newFormValue[key];
  });

  // // 继承值优先级高于默认值
  // if (lockCacheValue !== null) {
  //   return {...oldFormValue,language:initFormValue?.language}
  // }
  // setFormValue(initFormValue)
  return initFormValue;
};

// 获取对应日期的是周几，val为日期字符串
export const getWeekDay = (val: moment.MomentInput, weekDayArr: any[]) => {

  const dateVal = getLocale() === 'zh-CN' ? moment(val).isoWeekday() - 1 : moment(val).isoWeekday() - 1;
  // 兜底：这样写是为了当weekDayArr[dateVal]报错或者不存在时，能直接展示日期，不展示空的括号~lmy
  const weekDayStart = weekDayArr[dateVal] ? `(${weekDayArr[dateVal]})` : '';
  return weekDayStart;
};

// 获取对应日期的是周几，val为日期字符串
export const getWeekDayTitle = (title: string, weekDayArr: any, str = ' ~ ') => {
  let result = '';
  if (title?.includes(str)) {
    const titleArr = title?.split(str);
    const weekDayStart = getWeekDay(titleArr?.[0] || '', weekDayArr);
    const weekDayEnd = getWeekDay(titleArr?.[1] || '', weekDayArr);
    result = `${titleArr?.[0]}${weekDayStart} ~ ${titleArr?.[1]}${weekDayEnd}`;
  } else {
    const weekDay = getWeekDay(title || '', weekDayArr);
    result = title + weekDay;
  }
  return result;
};

// 根据属性property对对象数组排序
export const compare = (property: string | number) => function (a: { [x: string]: any; }, b: { [x: string]: any; }) {
  const value1 = a[property];
  const value2 = b[property];
  return value2 - value1;
};


export const moveArray = (arr: any[], sourceIndex: string | number, targetIndex: any) => {
  // splice 将目标元素替换并将原结果扔回来赋值给它
  arr[sourceIndex] = arr.splice(targetIndex, 1, arr[sourceIndex])[0];
  return arr;
};

/**
 * 获取字符串的宽度
 * @text   字符串
 * @fontSize  字符串显示时的fontSize
 * @fontWight  字符串显示时的fontWight
 */
export const getTextWidth = (text: string, fontSize = 12, fontWight = 400) => {
  const span = document.createElement('span');
  span.style.visibility = 'hidden';
  span.style.padding = '0';
  span.style['white-space'] = 'nowrap';
  span.style['overflow-x'] = 'auto';
  span.style.fontSize = fontSize > 12 ? `${fontSize}px` : '12px';
  span.style.fontWight = fontWight;
  document.body.appendChild(span);
  span.innerHTML = text;
  const width = span.offsetWidth;
  document.body.removeChild(span);
  return width;
};


/** Excel 工作表名禁止字符（SheetJS / Windows）：: \ / ? * [ ] */
const EXCEL_SHEET_NAME_MAX_LEN = 31;

/**
 * 净化工作表名，避免 book_append_sheet 抛错（如标题含 D1/D7 中的 `/`）
 */
export const sanitizeExcelSheetName = (raw: string | undefined | null): string => {
  const s0 = String(raw ?? '').trim();
  if (!s0) {
    return 'Sheet1';
  }
  const replaced = s0.replace(/[:\\/?*[\]]/g, '-').replace(/\s+/g, ' ').trim();
  const s = replaced || 'Sheet1';
  return s.length > EXCEL_SHEET_NAME_MAX_LEN
    ? s.slice(0, EXCEL_SHEET_NAME_MAX_LEN)
    : s;
};

/** 列样式提示（与 download IColumnFormatConfig.wrapText 语义一致） */
export type TExcelColumnStyleHint = { wrapText?: boolean; };

/**
 * 导出Excel文件
 * @param {string} fileName 文件名
 * @param {object[]} table 原始数值
 * @param {number[]} colWidth 列宽（可选）
 * @param {string} sheetName Sheet 名称（可选，默认为 "file"）
 * @param {TExcelColumnStyleHint[]} columnStyleHints 与列顺序一致；wrapText 为 true 的数据行单元格启用 Excel 自动换行
 */
export const exportExcel = async (
  fileName: string,
  table: never[] | undefined,
  colWidth: never[] = [],
  sheetName = 'file',
  columnStyleHints?: TExcelColumnStyleHint[],
) => {
  fileName = fileName?.replace(/\u0020/g, '_');

  setExportExcelDefaultStyle(table, columnStyleHints);
  // 创建book
  const XLSX = await import('xlsx-js-style');
  const wb = XLSX.utils.book_new();
  // json转sheet
  const ws = XLSX.utils.json_to_sheet(table, { header: [], skipHeader: true });
  if (colWidth && colWidth.length > 0) {
    ws['!cols'] = colWidth;
  } else {
    setExportExcelDefaultColWidths(ws, table);
  }
  // 下载时操作平台不允许输入半角冒号，所以用全角的代替
  const timestamp = moment().format('YYYY_MM_DD HH_mm_ss');

  const finalSheetName = sanitizeExcelSheetName(sheetName);

  // sheet写入book
  XLSX.utils.book_append_sheet(wb, ws, finalSheetName);
  // 输出
  XLSX.writeFile(wb, fileName ? `${fileName} ${timestamp}.xlsx` : `${timestamp}.xlsx`);
};

// 设置导出的Excel样式
export const setExportExcelDefaultStyle = (
  data = [],
  columnStyleHints?: TExcelColumnStyleHint[],
) => {
  const cols = Object.keys(data?.[0] ?? []);
  const defaultStyleAlign = {
    // 单元格垂直、水平居中
    alignment: {
      vertical: 'center',
      horizontal: 'center',
    },
  };

  const wrapTextBodyAlign = {
    alignment: {
      vertical: 'top',
      horizontal: 'left',
      wrapText: true,
    },
  };

  const defaultStyleFont = {
    font: {
      sz: 11,
      name: isWindow() ? '微软雅黑' : '苹方-简', // window操作系统的字体用微软雅黑,苹果操作系统的字体用苹方
    },
  };

  const defaultStyleBorder = {
    border: {
      top: {
        style: 'thin',
      },
      bottom: {
        style: 'thin',
      },
      left: {
        style: 'thin',
      },
      right: {
        style: 'thin',
      },
    }
  };

  const headDefaultStyle = {
    ...defaultStyleAlign,
    ...defaultStyleBorder,
    font: {
      sz: 11,
      name: isWindow() ? '微软雅黑' : '苹方-简',
      bold: true,
      color: {
        rgb: 'FFFFFF', // 白色
      },
    },
    fill: {
      fgColor: { rgb: '212C53' },
    },
  };

  const mergeHeaderStyle = (cellStyle = {}) => {
    const mergedStyle: any = {
      ...headDefaultStyle,
      ...cellStyle,
    };
    mergedStyle.font = {
      ...(headDefaultStyle as any).font,
      ...(cellStyle as any)?.font,
      bold: true,
    };
    return mergedStyle;
  };

  // const isNumbers: string[] = [] //寻找数值型的列
  // if (data?.[1]) {
  //   cols.forEach((k) => {
  //     let value = data[1][k]
  //     if (typeof value === 'object') {
  //       value = value.v
  //     }
  //     if (value === '-' || value === '' || value === null || isNumber(value)) {   //空内容或者内容是'-'的也认为是数值型的列
  //       isNumbers.push(k)
  //     }
  //   })
  // }

  // eslint-disable-next-line no-plusplus
  for (let i = data.length;i--;) {
    cols.forEach((k, colIndex) => {
      data[i][k] = formatExeclCommon(data?.[i]?.[k] ?? '');
      // if (isNumbers.indexOf(k) !== -1) {  //数值型的列右对齐
      //   data[i][k].s = { ...defaultStyleAlign, ...data[i][k]?.s }
      // }
      if (i === 0) {
        // Excel表头样式处理
        data[i][k].s = mergeHeaderStyle(data[i][k]?.s);
      } else {
        const useWrap = Boolean(columnStyleHints?.[colIndex]?.wrapText);
        const bodyAlign = useWrap ? wrapTextBodyAlign : defaultStyleAlign;
        data[i][k].s = {
          ...bodyAlign,
          ...defaultStyleFont,
          ...defaultStyleBorder,
          ...data[i][k]?.s,
        };
      }
    });
  }
};

// 设置导出的Excel的每列宽度
export const setExportExcelDefaultColWidths = (workSheet: { [x: string]: any[]; }, data = []) => {
  const colWidths: { wpx: number; }[] = [];
  Object.keys(data?.[0] ?? [])?.forEach(() => {
    // const value = data[0][k]?.v ?? '';
    const defaultWidth = 170;
    // let defaultWidth = 100
    // if (value) {
    //   const width = getTextWidth(value)
    //   if (width >= 90) {
    //     defaultWidth = width + 30
    //   }
    // }
    colWidths.push({ wpx: defaultWidth });
  });
  workSheet['!cols'] = colWidths;
};

// 是否是数值
export const isNumber = (value) => {
  if (value === '' || value == null) {
    return false;
  }
  return !isNaN(value);
};

// 是否是整数
export const isInteger = (value) => {
  if (isNumber(value)) {
    return Number.isInteger(parseFloat(value));
  }
  return false;
};


// 处理excel显示数据的公共方法
export const formatExeclCommon = (value: null, roundInteger = false) => {
  let data = value;
  if (typeof value !== 'object') {
    data = {
      v: value,
    };
  }
  if (data.z) {
    return data;
  }
  if (!isNumber(data.v)) {
    if (data.v === '' || value == null) {
      data.v = '-';
    }
    return data;
  }
  if (getIsErrorValue(data.v)) {
    data.v = '-';
    return data;
  }
  data.v = parseFloat(data.v);
  data.t = 'n';
  if (!data.z) {
    data.z = (roundInteger || isInteger(value)) ? '#,##0;-#,##0' : '##,##0.00 ;-##,##0.00';
  }
  return data;
};


export const timeFormatter = (time: moment.MomentInput, format = 'YYYY-MM-DD') => {
  if (!time) return time;
  const newTime = moment(time).format(format);
  if (newTime?.toLowerCase()?.includes('invalid')) {
    const timeArr = time.split('-');
    if (timeArr[0]?.length < 4) {
      timeArr[0] = timeArr[0]?.padStart(4, 0);
    }
    if (timeArr[1]) {
      timeArr[1] = timeArr[1]?.padStart(2, 0);
    }
    if (timeArr[2]) {
      timeArr[2] = timeArr[2]?.padStart(2, 0);
    }
    return moment(timeArr?.join('-')).format(format);
  }
  return newTime;
};

/**
 * 折线图空心圆点显示需求:
 *  整点刻度上的点显示圆点
 *  如果一个有数据的点的前后都没数据，那么他是一个孤立的点，这个时候显示圆点
 * @param options 折线图配置项
 * @param interval 间隔
 * @return 返回 圆点
 */
export function configLineChartPointSymbol(options, interval = 12) {
  const newSeries = options?.series?.map((item) => {
    item.symbol = 'none'; // 设置通用的图形
    item.showAllSymbol = true; // 控制显示所有图形
    // 计算需要显示空心圆的单独点配置
    item.data = item?.data?.map((value, index, array) => {
      // 整点刻度上的点显示圆点 index % interval === 0
      // 如果一个有数据的点的前后都没数据，那么他是一个孤立的点，这个时候显示圆点
      if (typeof value !== "object" && index % interval === 0 || (array[index - 1] === "" && array[index + 1] === "" && value !== "")) {
        return {
          value,
          symbol: item?.lineStyle?.type === 'solid' ? 'circle' : "emptyCircle",
          symbolSize: item?.lineStyle?.type === 'solid' ? 6 : 4,
        };
      }
      return value;
    });
    return { ...item };
  });
  return {
    ...options,
    series: newSeries,
  };
}

export const formatExeclNum = (value) => {
  if (getIsErrorValue(value)) return '-';
  return {
    v: parseFloat(value),  // 原始值
    t: 'n',                // 单元格数据类型: b Boolean, n Number, e error, s String, d Date
    z: '#,##0;-#,##0'      // 格式化方式
  };
};

export const formatExeclDecimal = (value) => {
  if (getIsErrorValue(value)) return '-';
  return {
    v: parseFloat(value),
    t: 'n',
    z: '##,##0.00 ;-##,##0.00'
  };
};

// 返回string 避免excel自带数字格式 1000 = 1,000
export const formatExcelString = (value) => {
  return {
    v: value,
    t: 's',
    z: '@'
  };
};

// 占比：百分比处理，保留一位
export const formatExeclSharePercent = (value) => {
  if (getIsErrorValue(value)) return '-';
  return {
    v: parseFloat(value),
    t: 'n',
    z: '##,##0.0%" ";-##,##0.0%'
  };
};
// 普通百分比
export const formatExeclNormalPercent = (value) => {
  if (getIsErrorValue(value)) return '-';
  return {
    v: parseFloat(value),
    t: 'n',
    z: '##,##0.00%" ";-##,##0.00%'
  };
};

export const formatExeclSharePercentDecimal = (value, decimalPlaces = 1) => {
  if (getIsErrorValue(value)) return '-';

  const decimals = Number.isInteger(decimalPlaces) && decimalPlaces >= 0 ? decimalPlaces : 1;

  return {
    v: parseFloat(value),
    t: 'n',
    z: `##,##0.${'0'.repeat(decimals)}%" ";-##,##0.${'0'.repeat(decimals)}%`
  };
};

// 获取涨跌箭头状态 no, zero, up, down
export const getUpAndDownStatus = (value, isNo?) => {
  if (isNo) return 'no';
  const num = Number(value);
  return num > 0 ? 'up' : (num === 0 ? 'zero' : 'down');
};


export const getTimepickerDefaultByType = (timeType, defaultValueByType) => {
  const result = { ...defaultValueByType };
  if (timeType in defaultValueByType) {
    result[timeType] = null;
  }
  return result;
};

export const getRangeDateLength = (date1, date2, type = 'day') => Math.abs(moment(date1).diff(date2, type.toLowerCase()));

const handleTable = (propTableOption: TableOption, hasManyDateColumns = false) => {
  const isMonth = propTableOption?.data?.[0]?.date?.length === 7 || propTableOption?.downloadData?.[0]?.date?.length === 7;
  if (propTableOption?.option?.length === 0 || isMonth) return propTableOption;
  const tableOption = cloneDeep(propTableOption);
  const { data, downloadData, option } = tableOption || {};
  const dateKey = option?.find(item => item?.key === 'date');
  const isEn = option?.find(item => item?.key === 'date')?.header === 'Date';
  const weekEnArr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const weekCnArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

  if (hasManyDateColumns) {
    const dateColumns = option?.filter(item =>
      item?.key?.toLowerCase()?.includes('date')
    );

    dateColumns?.forEach(dateCol => {
      const { key, header } = dateCol;
      const insertIndex = option.findIndex(o => o.key === key) + 1;
      const weekKey = `${key}_week_day`;

      option.splice(insertIndex, 0, {
        key: weekKey,
        header: `${header} ${isEn ? '(Day)' : '(星期)'}`,
      });

      [data, downloadData].forEach(list => {
        list?.forEach(item => {
          const val = item?.[key];
          if (val) {
            item[weekKey] = isEn
              ? weekEnArr[moment(val).day()]
              : weekCnArr[moment(val).day()];
          }
        });
      });
    });

    return tableOption;
  }

  if (dateKey) {
    option?.splice(1, 0, { key: 'week_day', header: isEn ? 'Day of week' : '星期' });
    data?.map(item => item.week_day = isEn ? weekEnArr[moment(item?.date).day()] : weekCnArr[moment(item?.date).day()]);
    downloadData?.map(item => item.week_day = isEn ? weekEnArr[moment(item?.date).day()] : weekCnArr[moment(item?.date).day()]);
  }

  return tableOption;
};

// 下载文件
export const handleDownload = (propTableOption: TableOption, title: any, isShowWeekDay = true, hasManyDateColumns = false) => {
  // 处理下载Excel增加日期周几
  const tableOption = isShowWeekDay ? handleTable(propTableOption, hasManyDateColumns) : propTableOption;
  const name = (tableOption.downloadTitle ?? title)?.replace(/\u0020/g, '_');
  const excelColumn = buildExcelColumns(tableOption?.option?.length ?? 0);
  // 表头行
  const headerRow: any = {};
  // 表头顺序
  const header: string[] = [];
  // 以 key 为顺序
  const keys: string[] = [];

  tableOption?.option?.forEach(item => {
    header.push(item.header);
    keys.push(item.key);
  });
  header?.forEach((item, index) => {
    headerRow[excelColumn[index]] = item;
  });
  const excelData: any = [headerRow];

  if (tableOption?.downloadData) {
    tableOption?.downloadData?.forEach((item) => {
      const itemData: any = {};
      keys?.forEach((key, index) => {
        itemData[excelColumn[index]] = item[key];
      });
      excelData.push(itemData);
    });
  } else {
    tableOption?.data?.forEach((item) => {
      const itemData: any = {};
      keys?.forEach((key, index) => {
        itemData[excelColumn[index]] = item[key];
      });
      excelData.push(itemData);
    });
  }
  /** 与 option 列顺序一致；透传 wrapText 供事件长文案等列启用 Excel 自动换行 */
  const columnStyleHints: TExcelColumnStyleHint[] | undefined =
    tableOption?.option?.map((item: { wrapText?: boolean; }) => ({
      wrapText: Boolean(item?.wrapText),
    }));
  const hasAnyWrap = columnStyleHints?.some(h => h.wrapText);
  // 导出excel
  exportExcel(
    name,
    excelData,
    [],
    'file',
    hasAnyWrap ? columnStyleHints : undefined,
  );
};

/**
 * 处理在 Day, Week , Month不同维度下, x轴显示的日期格式
 * @param {string} timeType 日期维度 Week|Month|Day
 * @param {string} date 日期
 * @param {boolean} isTable
 * @return {string} 返回处理后符合产品要求的日期格式字符串 string
 */
export const getChartDateFormatString = (timeType, date, isTable = false) => {
  if (!moment(date).isValid()) {
    return date;
  }
  if (isTable) {
    if (timeType === 'Month') {
      return moment(date).format('YYYY-MM');
    }
    return moment(date).format('YYYY-MM-DD');
  }
  if (timeType === 'Month') {
    return moment(date).format('YYYY-MM');
  }
  return moment(date).format('MM-DD');
};

export const localeKeyMap = {
  'others': '其他',
  'rest countries': '其他国家',
  'rest regions': '其他区域',
  'rest zones': '其他区服',
  'rest channels': '其他渠道',
} as any;

// 根据英文名处理
export const getDynamicLocalText = (type: any, enName, gameCode = 'test', locale, selectorList?) => {
  if (enName?.toLowerCase() === 'others') return locale === 'en-US' ? enName : '其他';
  if (enName === 'Rest Countries') return locale === 'en-US' ? enName : '其他国家';
  if (enName === 'Rest Regions') return locale === 'en-US' ? enName : '其他区域';
  if (enName === 'Rest Zones') return locale === 'en-US' ? enName : '其他区服';
  if (enName === 'Rest Channels') return locale === 'en-US' ? enName : '其他渠道';
  const map = selectorList ? getSelectorMap(selectorList)?.nameEnMap : getNameMap(gameCode);
  if (locale === 'en-US' || !gameCode || !map) {
    return enName;
  }
  return map?.[type]?.[enName] || enName;
};

// 根据code处理，主要是宽表应用，因为宽表中英文切换不请求接口，页面拿不到英文名称
export const getDynamicLocalCnEnText = (type: any, enName, gameCode = 'test', locale, selectorList?) => {
  if (enName?.toLowerCase() === 'others') return locale === 'en-US' ? enName : '其他';
  if (enName?.toLowerCase() === 'global') return locale === 'en-US' ? enName : '全球';
  if (enName?.toLowerCase() === 'total') return locale === 'en-US' ? enName : '全部';
  if (enName === 'Rest Countries') return locale === 'en-US' ? enName : '其他国家';
  if (enName === 'Rest Regions') return locale === 'en-US' ? enName : '其他区域';
  if (enName === 'Rest Zones') return locale === 'en-US' ? enName : '其他区服';
  if (enName === 'Rest Channels') return locale === 'en-US' ? enName : '其他渠道';
  const map = selectorList ? getSelectorMap(selectorList)?.nameCnMap : getCnEnNameMap(gameCode);
  if (!gameCode || !map) {
    return enName;
  }

  if (locale === 'en-US') {
    return map?.[type]?.[enName]?.en || enName;
  }
  return map?.[type]?.[enName]?.cn || map?.[type]?.[enName]?.en || enName;

};

// 对象数组去重，根据某一属性去重
export const unique = (arrObj: any, val: any) => {
  const result = new Map();
  // 逻辑：如果result中不存在item[val],则添加进去，下次就可以判断result中是否有添加过item[val]，有的话返回值就为false
  return arrObj?.filter((item: any) => !result.has(item[val]) && result.set(item[val], 1)) || [];
};

// 将 UTC+08:00 或 UTC+8:00 的格式转成 UTC+8 的格式
export const timeZoneTransformForShow = (timeZone) => timeZone?.replace(/\b(0(?=\d)|\:(\d)*)/gi, '');

// 将 UTC+08:00 UTC+8:00 的格式转成 UTC+08 的格式
export const timeZoneTransformForMoment = (timeZone) => timeZone?.replace(/\b([1-9](?!\d)|\:(\d)*)/gi, '0$1');

// 转'-'
export const nullToRung = (value) => {
  const flag = value === '' || value === null || value === undefined;
  return flag ? '-' : value;
};


// 判断数组中的某个属性是否全为空
export const isValNull = (targetArr: any[], attr: string) => {
  const resultValue = targetArr?.filter((item: any) => item?.[attr] !== null && item?.[attr] !== '');
  return resultValue?.length === 0;
};

export const getPathInfo = () => {
  const pathLenFlag = 4;
  const path = history?.location?.pathname;
  const pathArr = path.split('/');
  let realPath = '';
  let isBasePath = false;
  let basePath = '';
  if (pathArr.length <= pathLenFlag) {
    isBasePath = true;
  } else {
    realPath = `/${pathArr.filter((v, index) => index >= pathLenFlag).join('/')}`;
  }
  if (pathArr.length >= 4) {
    basePath = pathArr.filter((v, i) => i < pathLenFlag).join('/');
  }
  return {
    isBasePath,
    basePath,
    realPath
  };
};

export const getDimensionOption = (gameConfig, option, dataFrame, pageDefaultSelector?, pagePath?: string, useFrontFilterConfig?: boolean) => {
  let newOptions = option;
  const { default_selector: defaultSelector = [], page_selector: pageSelector = [] } = gameConfig || {};
  const pathInfo = parseUrlInfo(location.pathname);
  let { realPath } = pathInfo;

  realPath = pagePath || realPath; // 配置化path跟url不一致会导致筛选器取值错误

  if (realPath?.includes(gameConfig?.game_code)) {
    realPath = realPath?.split(`${gameConfig?.game_code}/`)?.[1];
  }

  const resultKeyArr = findPageSelector(realPath, pageSelector, defaultSelector, dataFrame, pageDefaultSelector, useFrontFilterConfig)?.filter(item => item.visible !== 0)?.map(item => item.key) || [];
  resultKeyArr?.includes('region') && resultKeyArr?.push('country');
  resultKeyArr?.includes('category') && resultKeyArr?.push('product');
  const index = resultKeyArr.indexOf('lang');

  if (index !== -1) {
    resultKeyArr[index] = 'language';
  }
  newOptions = newOptions?.filter(item =>
    // item.value = item.value === 'language' ? 'lang' : item.value
    resultKeyArr?.includes(item?.value) || item?.value === 'date' || item?.value === 'network_type'
  );
  return newOptions;
};

export const formatGamePhase = (phase: string | undefined, type = 'type', isNewGame = false, specialType) => {
  // 新增的类型就按 EA-SL,Test-CBT来做处理
  const gamePhaseMap: Array<any> = [
    {
      key: 'GL',
      type: 'GL',
      className: 'badge-gl',
      badgeClassName: 'drawer-context-left-sl drawer-context-left-gl',
    },
    {
      key: 'CBT',// pl
      type: 'CBT',
      className: 'badge-cbt',
      badgeClassName: 'drawer-context-left-cbt',
    },
    {
      key: 'SL', // ea
      type: 'SL',
      className: 'badge-sl',
      badgeClassName: 'drawer-context-left-sl',
    },
    {
      key: 'EA',
      type: 'SL',
      className: 'badge-sl',
      badgeClassName: 'drawer-context-left-sl',
    },
    {
      key: 'Test',
      type: 'CBT',
      className: 'badge-cbt',
      badgeClassName: 'drawer-context-left-cbt',
    },
    {
      key: 'NEW',
      type: 'NEW',
      className: 'badge-new',
      badgeClassName: 'drawer-context-left-new',
    }
  ];

  const specialTypeArr = ['EA', 'Test'];
  const isSpecialType = specialTypeArr?.includes(specialType);

  const target = gamePhaseMap?.find((item) => {
    const includesTargetVal = isSpecialType ? specialType : phase;
    return isNewGame ? item?.key === 'NEW' : includesTargetVal?.includes(item?.key);
  });
  return target?.[type] || '';
};


// 表格返回数据格式整理
export function getDateWeekDayStr(dateVal, formatMessage, timeType = "Day") {
  const WEEK_DAY_ARR = [
    formatMessage({ id: 'common_mon' }),
    formatMessage({ id: 'common_tues' }),
    formatMessage({ id: 'common_wed' }),
    formatMessage({ id: 'common_thur' }),
    formatMessage({ id: 'common_fri' }),
    formatMessage({ id: 'common_sat' }),
    formatMessage({ id: 'common_sun' }),
  ];
  let dateStr = getDateFormatString(timeType, dateVal); // 要显示周一日期
  dateStr = timeType === "Month" ? dateStr : dateStr + getWeekDay(dateStr, WEEK_DAY_ARR);
  const reg = /\((.+?)\)/gi;
  const weekValue = dateStr?.match(reg)?.[0]?.replace(/^\(/, "")?.slice(0, -1);
  let weekStr = '';
  if (weekValue) {
    if (weekValue?.includes('Null') || weekValue?.includes('去空')) {
      weekStr = `(${weekValue})`;
    } else {
      weekStr = weekValue;
    }
  }
  const isSunOrSat = weekStr === 'Sun' || weekStr === 'Sat' || weekStr === '周日' || weekStr === '周六';
  return { weekStr, isSunOrSat };
}

export const isMultipleEmails = (str: string) => {
  // 一个邮箱或者多个邮箱，以分号连接
  const regex = /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(;[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*;?$/;
  return regex.test(str);
};

// 时间处理
export const handleDate = (date: string, type: string): string => (type === 'MONTH' ? moment(date).format("YYYY-MM") : moment(date).format("YYYY-MM-DD"));

/**
 * 递归处理 copyData数据的中英文，主要处理getDynamicLocalCnEnText方法能拿到对应数值的数据，一般是 country | region | zone | channel | system
 * @param data 源数据
 * @param config 配置项
 * @description 支持数组，数组对象，多维数组对象，递归
 */
export const generateCopyData = (data: any,
  config: {
    extendMatch?: object;
    gameCode: 'test';
    selectorList?: any;
  }) => {
  const defaultMatch = {
    country_name: "country", // 国家
    region_name: "region", // 区域
    zone_name: "zone", // 区服
    channel_name: "channel", // 渠道
    system_name: "system" // 系统
  };
  const { gameCode, selectorList, extendMatch } = config;

  Object.assign(defaultMatch, extendMatch);
  const isObj = (flagData) => Object.prototype.toString.call(flagData) === "[object Object]";
  if (Array.isArray(data)) {
    for (const item of data) {
      generateCopyData(item, config);
    }
  } else if (isObj(data)) {
    for (const [key, value] of Object.entries(data)) {
      if (isObj(value)) {
        generateCopyData(value, config);
      } else {
        if (defaultMatch[key] && data[defaultMatch[key]]) {
          data[key] = getDynamicLocalCnEnText(defaultMatch[key], data[defaultMatch[key]], gameCode, getLocale(), selectorList);
        }
      }
    }
  }
  return data;
};

/**
 * 处理copyData数据的中英文
 * @description 主要用于{metricsList: []} 类型的数据
 * @param data
 * @param flagKey
 */
export const generateCopyDataForDimensionName = (data: any, flagKey = 'dimension_name') => {
  if (!data || !Array.isArray(data)) return data;
  const isEn = getLocale() === 'en-US';
  for (let i = 0;i < data.length;i++) {
    const item = data[i];
    const dimension_name = item[flagKey];
    for (const [key, value] of Object.entries(item)) {
      data[i][key] = dimension_name?.[`${key}_${isEn ? 'en' : 'cn'}`] || value;
    }
  }
  return data;
};

// 用于宽表，转换数据格式以便宽表使用
export const getArrObj = (arr) => {
  const resultObj = {};
  for (let i = 0;i < arr?.length;i++) {
    resultObj[arr[i].resName] = arr[i];
  }
  return resultObj;
};

export const formatParamsValues = (params: any): any => {
  const obj = {};
  (Object.keys(params || {})).forEach((key: string) => {
    obj[EXTRA_FILTER_KEY_MAP[key] || key] = params?.[key];
  });
  return obj;
};

// pc游戏Platform来源颜色映射处理
export const getSystemColor = (name) => {
  if (name?.trim()?.toLowerCase()?.startsWith('playstation') || name?.trim()?.toLowerCase()?.startsWith('ps')) {
    return PLATFORM_MAP?.playstation || '';
  }
  return PLATFORM_MAP?.[name?.toLowerCase()?.replace(/\s/g, '')] || '';
};


export const formatterPlatformList = (platformList: any[], platformDataList: any[]) => platformList?.map((item: any) => {
  const dataItem = platformDataList?.find((v: any) => v?.name === item?.os_id);
  const name = item?.os_name_en?.trim()?.toLowerCase();
  const icon = getSystemFlag(name) || defaultPlatforms?.icon;
  if (dataItem && dataItem?.value !== '') {
    return {
      title: item?.os_name_en,
      icon,
      hasData: true
    };
  }
  return {
    title: item?.os_name_en,
    icon,
    hasData: false
  };
}) || [];

// 页面配置化，获取filter信息
export const getServiceFilterParams = (filterVal, defaultTimeRange, isHavePeriod = true) => {
  // defaultTimeRange 每个页面后续可能不一样，所以不在这里做公共处理
  const { rangeTime, diff, timeType, ...filters } = filterVal || {};
  const rangeTimeArr = diff ? defaultTimeRange : formatSingleTime(rangeTime, timeType);
  const [start, end] = rangeTimeArr;
  const periodVal = PERIODTIMEOBJ?.[timeType] || 'daily';
  return {
    filters: formatFilterValues(filters),
    start_time: start,
    end_time: end,
    ...(isHavePeriod ? { period: periodVal } : {})
  };
};

export const commonValueFormatter = (type: any, value: string | number, decimal: number | undefined = 2) => {
  switch (type) {
    case 'int':
      // int类型整数 保留位数直接是0
      return dataFormat({ value, formatRule: { type: 'thousandsInt', decimal } });
    case 'decimals':
      return dataFormat({ value, formatRule: { type: 'thousandsDecimals', decimal } });
    case 'percent':
      return formatPercentNum(value, decimal, false);
  }
};

export const commonDownloadValueFormatter = (type: any, value: string | number) => {
  switch (type) {
    case 'int':
      // int类型整数 保留位数直接是0
      return formatExeclNum(value);
    case 'decimals':
      return formatExeclDecimal(value);
    case 'percent':
      return formatExeclNormalPercent(value);
  }
};

export const commonValueNoThousandFormatter = (type: any, value: string | number, decimal: number | undefined = 2) => {
  if (type === 'percent') {
    return formatPercentNum(value, decimal, false);
  }
  return dataFormat({ value, formatRule: { type, decimal } });
};

export const getDateVal = (value: Moment | string, formatStr?: string = dateFormatStr) => {
  if (!value) {
    return null;
  }
  return isMoment(value) ? value?.format(formatStr) : value;
};

export const changeDateTypeValue = (value: Moment | string, formatStr?: string = dateFormatStr) => isMoment(value) ? value?.format(formatStr) : moment(value);

// 处理保存后端筛选器方案的时间值
export const formatFilterKey = (filtrs: { [key: string]: any; }) => {
  const newFilters: { [key: string]: any; } = {};
  Object.keys(filtrs)?.map((key: string) => {
    // 格式化时间
    if (key === RANGE_DAILY) {
      const [start, end] = filtrs[key] || [];
      newFilters[key] = [moment(start), moment(end)];
    } else {
      newFilters[key] = filtrs[key];
    }
  });
  return newFilters;
};

export const getFilterSaveListVal = (res: any) => {
  const result = res?.map((item: any) => ({
    ...item,
    filter_cond: {
      ...(item?.filter_cond || {}),
      // 把后端返回的下划线命名转为驼峰命名
      ext_filter: { ...(formatFilterKey(item?.filter_cond?.ext_filter || {}) || {}) }
    }
  })) || [];
  return result;
};

// 迁移页面中筛选器业务逻辑的方法firstWordUpper
export const firstDateWordUpper = (str: string) => {
  if (!str) return str;
  const firstLetter = str.charAt(0);
  const firstLetterCap = firstLetter.toUpperCase();
  const remainingLetters = str.slice(1);
  return firstLetterCap + remainingLetters === 'Date' ? 'Day' : firstLetterCap + remainingLetters;
};
// 将'game_code= 123;type=game'类型字符串转化为对象格式
export const strToObject = (str: string) => {
  const obj = {};
  const keyValuePairs = str.split('&');
  keyValuePairs.forEach(pair => {
    let [key, value] = pair.split('=');
    if (!key || !value) return;
    key = key.trim();
    value = value.trim();
    if (key === "" || value === "") return;
    obj[key] = value;
  });
  return obj;
};


// 在原有页面中formatLittleNum方法的基础上修改，arpu特小值类型指标处理
// 当前只有arpu的指标处理用到
export const formatSmallValue = (val: any, type: string, decimal: number | undefined) => {
  if (getIsErrorValue(val)) return '-';
  if (isNaN(val)) return val;
  const value = val - 0;
  // 当前不存在小于0的情况，这里做个兜底
  if (value <= 0) {
    // return parseFloat(value.toFixed(2));
    // 用numeral转换，可以使0的时候也保留0.00
    return numeral(val).format('0.00');
  }
  // 下面极小值处理不用numeral，是因为，numeral在小于一定数值时，转换后因为精度问题会是NaN
  // 如：numeral(0.00000011).format('0.00000000') 返回的是NaN
  if (value > 0 && value < 1) {
    if (value <= 0.000001) {
      return parseFloat(value.toFixed(8));
    }
    if (value <= 0.00001) {
      return parseFloat(value.toFixed(7));
    }
    if (value <= 0.0001) {
      return parseFloat(value.toFixed(6));
    }
    if (value <= 0.001) {
      return parseFloat(value.toFixed(5));
    }
    if (value <= 0.01) {
      return parseFloat(value.toFixed(4));
    }
    if (value <= 0.1) {
      return parseFloat(value.toFixed(3));
    }
  }
  return commonValueNoThousandFormatter(type, val, decimal);
};

const getFixedNumber = (value, decimal, isAxis = false) => {
  // 坐标轴：value * 100后获得的百分比为0则保留0，如果百分比大于0%小于0.1%（实际坐标轴为0.0X%）则保留2位小数，以此类推
  // 浮窗等数据展示：除了0之外，在坐标轴基础上+1位，这样能保证折线是一个曲线而不是水平线
  const num = isAxis ? 0 : 1;
  if (value === 0 && isAxis) {
    return 0;
  }
  if (value <= 0.000001) {
    return 6 + num;
  }
  if (value <= 0.00001) {
    return 5 + num;
  }
  if (value <= 0.0001) {
    return 4 + num;
  }
  if (value <= 0.001) {
    return 3 + num;
  }
  return decimal;
};



export const formatSmallPercent = (val: number, decimal: number | undefined = 2, isAxis?: boolean) => {

  if (getIsErrorValue(val)) return '-';
  if (isNaN(val)) return val;
  // 取绝对值，因为会传进来负数
  const value = Math.abs(val);
  let fixedNumber = getFixedNumber(value, decimal, isAxis);
  if (Math.abs(val) === 0 && (val !== 0 || val !== '0')) {
    fixedNumber = decimal;
  }

  if (val < 0) return `-${formatPercentNum(value, fixedNumber, false, false, false)}`;
  return formatPercentNum(value, fixedNumber, false, false, false);
};

export const firstWordUpper = (str: string) => {
  if (!str) return str;
  const firstLetter = str.charAt(0);
  const firstLetterCap = firstLetter.toUpperCase();
  const remainingLetters = str.slice(1);
  return firstLetterCap + remainingLetters === 'Date' ? 'Day' : firstLetterCap + remainingLetters;
};

export function getTableDate(time, timeType) {
  switch (timeType) {
    case 'weekly':
      return getCurrWeekfirstDay(time);
    case 'monthly':
      return momentFormat(time, 'YYYY-MM');
    default:
      return time;
  }
}

// 下钻跳转公共方法
export const jumpDetail = (path: string, filterVal: filterValueType, metric?: string, otherParams?: any) => {
  const { diff } = filterVal;
  history.push(
    path,
    JSON.stringify({ hasBack: true, indicators: metric, ...(!diff ? { filterParams: filterVal } : {}), otherParams})
  );
};

// 提取公共的URL构建逻辑
const buildUrlWithParams = (path: string, item: Record<string, any>): string => {
  // 使用 'comma' 格式化数组为逗号分隔字符串
  const query = queryString.stringify(item, {
    arrayFormat: 'comma',
  });

  // 判断 path 是否已经包含 '?'
  const separator = path?.includes('?') ? '&' : '?';

  // 拼接查询参数到路径
  const url = query ? `${path}${separator}${query}` : path;

  return url;
};

// 打开新窗口url继承方法
export const openWithParams = (path: string, item: Record<string, any>) => {
  const url = buildUrlWithParams(path, item);

  window.open(url);
};

// 获取url继承方法
export const getJumpWithParams = (path: string, item: Record<string, any>) => {
  return buildUrlWithParams(path, item);
};

// 日期处理
export const handleAxisFormat = (value: string, timeType: string) => timeType === "Month" ? dateTimeFormat(value, 'month') : dateTimeFormat(value, 'mDay');

// 获取对应月的最后一天
export const formatRetentionDate = (rangeTime:Moment [],type: 'Day' | 'Week' | 'Month' = 'Day') => {
  const [start, end] = rangeTime;
  if(type?.toLocaleLowerCase() === 'month') {
    return [start, end?.endOf('month')];
  }
  return rangeTime;
};


// 获取接口其他参数
export const otherParamsVal = (otherParams: any, otherConditions: any) => {
  if(typeof otherParams === 'function') {
    return otherParams(otherConditions);
  }
  if(typeof otherParams === 'string') {
    return stringToFunction?.(otherParams)?.(otherConditions);
  }
  return otherParams || {};
};

export const formatSelectorToLanguageMap = (data, codeKey,iconKey,  enKey, cnKey, isEn) => {
  const result = {};
  data?.forEach(item => {
    result[item?.[codeKey]] = {
      name: getLanguage(isEn, item?.[enKey], item?.[cnKey]),
      ...(iconKey ? {icon: item?.[iconKey]} : {})

    };
  });
  return result;
};

export const formateCategoryName = (categoryName, maxWidth?: number, fontSizeWidth?: number) => {
  // 每行最多可以显示的字符数
  const maxCharsPerLine = Math.floor((maxWidth || 70) / (fontSizeWidth || 6));

  // 拆分以单词为单位（按空格切割）
  const words = categoryName.split(' ');
  const lines: string[] = [];
  let currentLine = '';

  // 遍历单词，累积拼接至当前行
  for (const word of words) {
    // 如果加入当前行后不会超出限制，直接累加
    if (currentLine.length + word.length <= maxCharsPerLine) {
      currentLine += (currentLine ? ' ' : '') + word;
    } else {
      // 如果加入当前行后会超出限制，将当前行存储，然后开始下一行
      lines.push(currentLine);
      currentLine = word;
    }
  }

  // 将最后一行添加进数组（如果存在内容）
  if (currentLine) {
    lines.push(currentLine);
  }

  return lines.join('\n'); // 使用换行符拼接所有行
};

type TimeUnit = 'years' | 'months' | 'days' | 'hours' | 'minutes' | 'seconds';

/**
 * 检查时间区间是否超过指定限制
 *
 * @param start 开始时间 (Moment)
 * @param end 结束时间 (Moment)
 * @param unit 粒度 ('years' | 'months' | 'days' | 'hours' | 'minutes' | 'seconds')
 * @param limit 限制数量，比如 2 表示两年 / 六个月 / 30 天 / 48 小时 / 120 分钟 / 60 秒
 * @returns boolean 是否超过限制
 */
export function isRangeTimeOverLimit(
  start: Moment | null | undefined,
  end: Moment | null | undefined,
  unit: TimeUnit,
  limit: number
): boolean {
  // 参数校验
  if (!start || !end) return false;
  if (!moment.isMoment(start) || !moment.isMoment(end)) return false;
  if (typeof limit !== 'number' || limit <= 0) return false;

  // 计算差值
  const diff = end.diff(start, unit, true); // true 保留小数
  return diff > limit;
}

// 根据时间限制生成提示文案的函数
export const getRangeTimeLimitMsg = (gameCode?: string) => {
  let timeLimit;

  if (IS_GLOBAL) {
    timeLimit = gameCode && RANGE_TIME_LIMIT_BY_GAME?.[gameCode]
      ? RANGE_TIME_LIMIT_BY_GAME?.[gameCode]
      : RANGE_TIME_LIMIT;
  } else {
    timeLimit = RANGE_TIME_LIMIT_NOT_GLOBAL;
  }

  return {
    en: `Query period limited to ${timeLimit} years. For longer periods, <br/>please contact <a href="mailto:evansong@tencent.com">evansong@tencent.com</a>`,
    cn: `查询时间跨度仅支持${timeLimit}年，如需查询更多，<br/>请联系 <a href="mailto:evansong@tencent.com">evansong@tencent.com</a>`,
  };
};

/**
 * 标准化 formatRules，将 keys 数组转换为单个 key 的规则数组
 * @param formatRules - IFormatRules[] 格式的规则数组（每项包含 keys 数组）
 * @returns IFormatRule[] 标准化后的规则数组（每项包含单个 key）
 */
export const normalizeFormatRules = (formatRules?: IFormatRules[]): IFormatRule[] => {
  if (!formatRules || formatRules.length === 0) {
    return [];
  }

  try {
    return formatRules.flatMap((rule: IFormatRules) => {
      if (!rule.keys) return [];

      if (Array.isArray(rule.keys)) {
        return rule.keys.map((key: string) => {
          const { keys, ...restRule } = rule;
          return { ...restRule, key };
        });
      }

      if (typeof rule.keys === 'string') {
        const { keys, ...restRule } = rule;
        return [{ ...restRule, key: keys as string }];
      }

      return [];
    });
  } catch (error) {
    console.error('normalizeFormatRules 解析错误:', error);
    return [];
  }
};
